import { c as _c } from "react/compiler-runtime";
import type { Route } from 'next';
import type { SocialMediaAccountService } from '#types/global';
import { IconSystemLink } from '../base/IconButton/IconSystemLink';
import styles from './AuthorHeaderSocialMediaAccount.module.scss';
type Props = {
  label: string | null | undefined;
  service: SocialMediaAccountService | null | undefined;
  url: Route | null | undefined;
  className?: string;
};
function getIconForService(service: SocialMediaAccountService) {
  switch (service) {
    case 'EMAIL':
      return {
        icon: 'mail',
        variant: 'filled',
        title: 'Email'
      } as const;
    case 'FACEBOOK_PAGE':
      return {
        icon: 'facebook',
        variant: 'filled',
        title: 'Facebook'
      } as const;
    case 'INSTAGRAM':
      return {
        icon: 'instagram',
        variant: 'filled',
        title: 'Instagram'
      } as const;
    case 'SPOTIFY':
      return {
        icon: 'spotify',
        variant: 'filled',
        title: 'Spotify'
      } as const;
    case 'TWITTER':
      return {
        icon: 'twitter-x',
        variant: 'filled',
        title: 'X'
      } as const;
    case 'YOUTUBE':
      return {
        icon: 'youtube',
        variant: 'filled',
        title: 'Youtube'
      } as const;
  }
}
export function AuthorHeaderSocialMediaAccount(t0) {
  const $ = _c(10);
  const {
    label,
    service,
    url,
    className
  } = t0;
  if (!service || !url) {
    return null;
  }
  let t1;
  if ($[0] !== service) {
    t1 = getIconForService(service);
    $[0] = service;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    icon,
    variant,
    title
  } = t1;
  const t2 = `${styles.listItem} ${className ? className : ""}`;
  const t3 = label || title;
  let t4;
  if ($[2] !== icon || $[3] !== t3 || $[4] !== url || $[5] !== variant) {
    t4 = <IconSystemLink href={url} icon={icon} variant={variant} title={t3} type="secondary" />;
    $[2] = icon;
    $[3] = t3;
    $[4] = url;
    $[5] = variant;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <li className={t2}>{t4}</li>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}